import {getMstStore} from '$src/bootstrap/rootSaga'
import {IStore} from '$src/bootstrap/Store'
import {channelOfSnapshots} from '$src/comparableSales/sagas/sagas'
import {take} from 'redux-saga/effects'
import {getSnapshot, applySnapshot} from 'mobx-state-tree'
import callEndpoint from '$src/api/sagas/callEndpoint'
import getUsers from '../api/endpoints/users/getAll'
import {keyBy} from 'lodash'

export default function* usersRootSaga(): Generator {
  const mstStore: IStore = (yield getMstStore()) as $IntentionalAny
  const theChannel = yield channelOfSnapshots(mstStore.auth)

  let wasLoggedIn = false
  while (true) {
    const {isLoggedIn} = getSnapshot(mstStore.auth.__state)

    if (!isLoggedIn) {
      wasLoggedIn = false
    } else if (isLoggedIn !== wasLoggedIn) {
      wasLoggedIn = true

      const result = yield callEndpoint(getUsers)
      const byId = keyBy(result, '_id')
      applySnapshot(mstStore.users.byId, byId)
    }

    yield take(theChannel)
  }
}



// WEBPACK FOOTER //
// ./src/users/sagas.tsx